// Owners prevent one nested panel from unlocking another. CSS applies this on mobile only.
const owners = new Set()

export function setMobileScrollLock(owner, locked) {
  if (locked) owners.add(owner)
  else owners.delete(owner)
  document.body.classList.toggle('jl-mobile-scroll-locked', owners.size > 0)
}



// WEBPACK FOOTER //
// ./src/utils/mobileScrollLock.js